import { useLogger } from "@amzn/xb-hooks";
import { useQuery } from "@apollo/client";
import { FC } from "react";
import { LiveInterceptorFactoryInfo } from "../../live-component";
import { PrefetchQueryInterface } from "./types";

export const prefetchQueryInterceptorFactory = <TProps extends PrefetchQueryInterface>(
  { fallback = <></> }: LiveInterceptorFactoryInfo,
  Response: FC<any>
) => {
  const ResponseWithPrefetchQuery: FC<TProps> = ({ prefetchQueryCallback, ...otherProps }) => {
    const { query, variables, isBlocking, skip } = prefetchQueryCallback?.(otherProps) ?? {};
    const logger = useLogger();

    // Defining Prefetch as it's own component to avoid initiating useQuery when query was not passed
    const Prefetch = () => {
      const { loading } = useQuery(query!, {
        variables,
        fetchPolicy: "cache-first",
        onError(error) {
          logger.error("Error encountered during prefetch query", error);
        },
        onCompleted(data) {
          logger.debug("Prefetch query completed", data);
        },
        skip,
      });

      if (isBlocking && loading) {
        return <>{fallback}</>;
      } else {
        return <Response {...otherProps} />;
      }
    };

    return query ? <Prefetch /> : <Response {...otherProps} />;
  };

  return ResponseWithPrefetchQuery;
};
